import { Component, OnInit } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { FiltrosProducaoRetornoService } from '../../../../filters/filtros-producaoretorno.service';
import { ProducaoRetornoService } from '../../../../services/producaoretorno.service';

@Component({
  selector: 'app-producaocana',
  templateUrl: './producaocana.component.html',
  styleUrl: './producaocana.component.css',
  providers: [ConfirmationService],
})
export class ProducaoCanaComponent implements OnInit {
  registros: any[] = [];
  totalRecords: number = 0;
  loading: boolean = false;

  dataInicio: string = '';
  dataFim: string = '';
  instancia: string = '';

  // Integração
  displayIntegrarDialog: boolean = false;
  integrationDate: Date | undefined;
  selectedInstancia: string = '';
  maxDate: Date = new Date();
  loadingIntegracao: boolean = false;

  // Resultado da integração
  resultadoIntegracao: any = null;
  erroIntegracao: string = '';
  loadingEnvio: boolean = false;

  // Detail dialog
  displayDetalhes: boolean = false;
  itemSelecionado: any = null;

  canaItemsMap: { key: string; label: string }[] = [
    { key: 'valor025', label: 'Cana Spot' },
    { key: 'valor012', label: 'Cana Própria' },
    { key: 'valor014', label: 'Cana Parceria' },
    { key: 'valor013', label: 'Cana Fornecedor' },
  ];

  constructor(
    private producaoRetornoService: ProducaoRetornoService,
    private filterService: FiltrosProducaoRetornoService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService
  ) {}

  ngOnInit() {
    this.maxDate = new Date();
    this.maxDate.setDate(this.maxDate.getDate() - 1);
    this.getFiltros();
  }

  getFiltros() {
    this.filterService.currentInstancia.subscribe((instancia) => {
      this.instancia = instancia;
      this.carregarDados();
    });
    this.filterService.currentDataInicio.subscribe((inicio) => {
      this.dataInicio = inicio;
      this.carregarDados();
    });
    this.filterService.currentDataFim.subscribe((fim) => {
      this.dataFim = fim;
      this.carregarDados();
    });
  }

  carregarDados() {
    if (this.instancia && this.dataInicio && this.dataFim) {
      this.loading = true;
      this.producaoRetornoService
        .getProducaoCana(0, 1000, this.instancia, this.dataInicio, this.dataFim)
        .subscribe({
          next: (data) => {
            this.registros = data.content ?? data;
            this.totalRecords = data.totalElements ?? this.registros.length;
            this.loading = false;
          },
          error: () => {
            this.loading = false;
          }
        });
    }
  }

  showIntegrarDialog() {
    this.displayIntegrarDialog = true;
    this.integrationDate = undefined;
    this.selectedInstancia = '';
    this.resultadoIntegracao = null;
    this.erroIntegracao = '';
  }

  integrar() {
    if (!this.integrationDate || !this.selectedInstancia) return;

    const day = this.integrationDate.getDate().toString().padStart(2, '0');
    const month = (this.integrationDate.getMonth() + 1).toString().padStart(2, '0');
    const year = this.integrationDate.getFullYear();

    const request = {
      instancia: this.selectedInstancia,
      dataReferencia: `${day}/${month}/${year}`
    };

    this.loadingIntegracao = true;
    this.erroIntegracao = '';
    this.resultadoIntegracao = null;

    this.producaoRetornoService.integrarProducaoCana(request).subscribe({
      next: (data) => {
        this.resultadoIntegracao = data;
        this.displayIntegrarDialog = false;
        this.loadingIntegracao = false;
        this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: 'Dados buscados do PIMS e salvos com sucesso.' });
        this.carregarDados();
      },
      error: (err) => {
        this.loadingIntegracao = false;
        this.erroIntegracao = this.extractErrorMsg(err, 'Erro ao buscar do PIMS');
        this.messageService.add({ severity: 'error', summary: 'Erro', detail: this.erroIntegracao });
      }
    });
  }

  processar() {
    if (!this.resultadoIntegracao) return;

    this.loadingEnvio = true;
    this.producaoRetornoService.enviarProducaoCana(this.resultadoIntegracao).subscribe({
      next: (msg) => {
        this.loadingEnvio = false;
        this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: msg || 'Produção Cana processada com sucesso.' });
        this.resultadoIntegracao = null;
        this.carregarDados();
      },
      error: (err) => {
        this.loadingEnvio = false;
        this.resultadoIntegracao = null;
        const errorMsg = this.extractErrorMsg(err, 'Erro ao processar');
        this.messageService.add({ severity: 'error', summary: 'Erro', detail: errorMsg });
        this.carregarDados();
      }
    });
  }

  descartarResultado() {
    this.resultadoIntegracao = null;
    this.erroIntegracao = '';
  }

  showDetalhes(item: any) {
    this.itemSelecionado = item;
    this.displayDetalhes = true;
  }

  getCanaItems(item: any): { material: string; quantidade: any }[] {
    return this.canaItemsMap.map(m => ({
      material: m.label,
      quantidade: item[m.key] != null ? item[m.key] : 0
    }));
  }

  private extractErrorMsg(err: any, fallback: string): string {
    let msg = fallback;
    if (typeof err.error === 'string') {
      msg = err.error;
    } else if (err.error?.message) {
      msg = err.error.message;
    } else if (err.message) {
      msg = err.message;
    }
    return msg.length > 300 ? msg.substring(0, 300) + '...' : msg;
  }

  confirmEnviarSap(item: any) {
    this.confirmationService.confirm({
      message: `Deseja enviar ao SAP o registro da empresa <b>${item.empresa}</b>, filial <b>${item.filial}</b> com data <b>${item.dataMovimento}</b>?`,
      header: 'Confirmar Integração SAP',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'none',
      rejectIcon: 'none',
      acceptLabel: 'Sim, enviar',
      rejectLabel: 'Não',
      accept: () => {
        const dataMovimentoIso = this.converterDataParaIso(item.dataMovimento);
        this.producaoRetornoService.enviarProducaoCanaPorRegistro(item.empresa, item.filial, dataMovimentoIso).subscribe({
          next: (msg) => {
            this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: msg || 'Produção Cana enviada ao SAP com sucesso.' });
            this.carregarDados();
          },
          error: (err) => {
            const errorMsg = this.extractErrorMsg(err, 'Erro ao enviar ao SAP');
            this.messageService.add({ severity: 'error', summary: 'Erro', detail: errorMsg });
            this.carregarDados();
          }
        });
      }
    });
  }

  private converterDataParaIso(data: string): string {
    if (!data) return data;
    const partes = data.split('/');
    if (partes.length === 3) {
      return `${partes[2]}-${partes[1]}-${partes[0]}`;
    }
    return data;
  }
}
